// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"ChangeStatus_wrapperComponent__deUFl","actions":"ChangeStatus_actions__rleJ9"};